import React from 'react'

const Survey = () => {
  return (
    <div>survey</div>
  )
}

export default Survey